import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import ReactSlider from 'react-slider';

import Colors from '../../resource/ResourceColors.jsx';
import {clamp} from '../../util/UtilMidi.jsx';

const MIN_ZOOM_LOG = 1;
export const DEFAULT_ZOOM_LOG = 3;
const TRACK_BORDER_REM = 0.25;

const ZoomSlider = styled.div`
    position:fixed;
    background: ${Colors.right_diagonal_gradient_grey(70, 60)};
    right: 0;
    left: 85%;
    bottom: 0;
    margin-left: ${TRACK_BORDER_REM}rem;
    height: 1rem;
`;

const StyledSlider = styled(ReactSlider)`
    height: 1rem;
    box-shadow: inset ${Colors.wide_raw_shadow(30)}};
`;

const StyledThumb = styled.div`
    height: 1rem;
    width: 1rem;
    background: ${Colors.right_diagonal_gradient_grey(90, 60)};
    cursor: grab;
    border-radius: 0.25rem;
    box-shadow: ${Colors.wide_raw_shadow(30)}};
`;

const StyledTrack = styled.div`
    margin: 0.5rem;
`;

export class TrackZoom extends Component {

    static propTypes = {
        duration_ms: PropTypes.number.isRequired,
        handle_zoom: PropTypes.func.isRequired
    }

    state = {
        zoom_log: DEFAULT_ZOOM_LOG
    };

    zoom(zoom_log) {
        const zoom_factor = Math.exp(zoom_log);
        this.props.handle_zoom(zoom_factor);
        this.setState({zoom_log: zoom_log})
    }

    render() {
        const thumb = (props, state) => <StyledThumb {...props} />
        const track = (props, state) => <StyledTrack {...props} index={this.state.zoom_log}/>;
        const max_zoom_log = clamp (Math.log(this.props.duration_ms / 1500), 1, 1000); // should be width of tracks div
        return <ZoomSlider>
            <StyledSlider
                max={max_zoom_log}
                min={MIN_ZOOM_LOG}
                step={0.25}
                orientation={'horizontal'}
                value={this.state.zoom_log}
                renderTrack={track}
                renderThumb={thumb}
                onChange={zoom_log => this.zoom(zoom_log)}
            />
        </ZoomSlider>
    }
}

export default TrackZoom;
